<div class="maia-upload-step" data-testid="maia-upload-panel">

    <maia-guidelines-panel *ngIf="showGuidelines"
                           [isDownloadingTemplate]="isDownloadingTemplate"
                           [templateError]="templateError"
                           (closed)="closeGuidelines()"
                           (templateRequested)="downloadTemplate()"></maia-guidelines-panel>

    <div class="step-canvas">
        <div class="step-stage">

            <section class="wizard-card" data-testid="maia-upload-card">


                <h2 class="card-title">Upload your Portfolio</h2>

                <p class="card-description">
                    Upload your portfolio or geo-data file. MAPTYCS will automatically detect structure,
                    map columns, and enrich your data. Before uploading, please review the upload
                    guidelines to ensure the best results.
                </p>

                <div class="info-strip info-strip-accent">
                    <svg class="strip-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/>
                        <path d="M12 11v5.5M12 7.75v.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
                    </svg>
                    <a class="guidelines-link"
                       data-testid="maia-upload-guidelines-link"
                       href="javascript:void(0)"
                       (click)="openGuidelines()">See upload guidelines</a>
                </div>

                <input #fileInput
                       type="file"
                       class="file-input"
                       data-testid="maia-file-input"
                       [attr.accept]="acceptAttribute"
                       (change)="onFileInputChange($event)"/>

                <div class="dropzone"
                     [class.dropzone-active]="isDragOver"
                     [class.dropzone-error]="errorMessage"
                     data-testid="maia-upload-dropzone"
                     (dragover)="onDragOver($event)"
                     (dragleave)="onDragLeave($event)"
                     (drop)="onDrop($event)">

                    <ng-container *ngIf="!isBusy">
                        <span class="dropzone-icon" aria-hidden="true">
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                                <path d="M6.5 18a4 4 0 0 1-.3-7.99A5.5 5.5 0 0 1 17.4 9.2 3.9 3.9 0 0 1 17.5 18"
                                      stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M12 20.5v-7M9.5 15.5 12 13l2.5 2.5"
                                      stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>

                        <p class="dropzone-title">Drag &amp; drop your file here</p>
                        <p class="dropzone-hint">CSV, XLSX, JSON - up to 50MB</p>
                        <p class="dropzone-or">or</p>

                        <button type="button"
                                class="primary-button"
                                data-testid="maia-browse-files-button"
                                (click)="openFilePicker()">
                            Browse files
                        </button>
                    </ng-container>

                    <ng-container *ngIf="isBusy">
                        <mat-progress-spinner class="dropzone-spinner"
                                              mode="indeterminate"
                                              diameter="36"
                                              color="primary"></mat-progress-spinner>
                        <p class="dropzone-title" data-testid="maia-upload-progress">
                            {{ isParsing ? 'Parsing your file…' : 'Uploading your file…' }}
                        </p>
                        <p class="dropzone-hint">{{ fileSummary }}</p>

                        <!-- Live stage text / progress pushed over SSE. -->
                        <p *ngIf="isParsing" class="dropzone-hint" data-testid="maia-parsing-message">
                            {{ parsingMessage || 'This can take a moment for large workbooks.' }}
                        </p>

                        <div *ngIf="isParsing && parsingPercent !== null"
                             class="parse-progress"
                             data-testid="maia-parsing-progress">
                            <div class="parse-progress-track">
                                <div class="parse-progress-fill" [style.width.%]="parsingPercent"></div>
                            </div>
                            <span class="parse-progress-value">{{ parsingPercent }}%</span>
                        </div>
                    </ng-container>
                </div>

                <div *ngIf="errorMessage" class="dropzone-error-text" data-testid="maia-upload-error">
                    <span>{{ errorMessage }}</span>
                    <ng-container *ngIf="activeJobId !== null; else plainRetry">
                        <button type="button"
                                class="link-button link-button-error"
                                data-testid="maia-upload-resume-active-button"
                                (click)="resumeActiveJob()">
                            Resume job #{{ activeJobId }}
                        </button>
                        <button *ngIf="selectedFile"
                                type="button"
                                class="link-button link-button-error"
                                data-testid="maia-upload-close-and-upload-button"
                                (click)="closeActiveJobAndUpload()">
                            Close it and upload this file
                        </button>
                    </ng-container>
                    <ng-template #plainRetry>
                        <button *ngIf="selectedFile"
                                type="button"
                                class="link-button link-button-error"
                                data-testid="maia-upload-retry-button"
                                (click)="retryUpload()">
                            Try again
                        </button>
                    </ng-template>
                </div>

                <div class="info-strip info-strip-muted">
                    <svg class="strip-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path d="M12 3.5 13.4 8 18 9.4 13.4 10.8 12 15.3 10.6 10.8 6 9.4 10.6 8z"
                              stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>
                        <path d="M17.5 15l.7 2.2 2.3.8-2.3.8-.7 2.2-.7-2.2-2.3-.8 2.3-.8z"
                              stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>
                    </svg>
                    <span class="strip-text">MAPTYCS will scan your file structure automatically</span>
                </div>

            </section>

        </div>
    </div>
</div>
